<template>
  <b-overlay
      :show="wallets === null"
      rounded="sm"
  >

    <div v-if="wallets !== null">

      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-0"
      >

        <div class="m-2">

          <!-- Table Top -->
          <b-row>

            <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>نمایش</label>
              <v-select
                  v-model="perPage"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>تعداد</label>
            </b-col>

            <!-- Search -->
            <b-col
                cols="12"
                md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    v-model="searchQuery"
                    class="d-inline-block mr-1"
                    placeholder="جستجو..."
                />
<!--                <b-button-->
<!--                    variant="primary"-->
<!--                    @click="isAddNewUserSidebarActive = true"-->
<!--                >-->
<!--                  <span class="text-nowrap">اضافه کردن کاربر</span>-->
<!--                </b-button>-->
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="wallets"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
        >

          <template #cell(name)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                    size="45"
                    :src="`https://api.faradidar.com/${data.item.userInfo.selfieFileData}`"
                    :variant="`success`"
                    :to="{ name: 'apps-users-edit', params: { id: data.item.userInfo.userId } }"
                />
              </template>
              <b-link
                  :to="{ name: 'apps-users-edit', params: { id: data.item.userInfo.userId } }"
                  class="font-weight-bold d-block text-nowrap"
              >
                {{ data.item.userInfo.name+' '+data.item.userInfo.familyName }}
              </b-link>
              <small class="text-muted">@{{ data.item.userId }}</small>
            </b-media>
          </template>

          <!-- Column: walletId -->
          <template #cell(walletId)="data">
            <b-badge
                pill
                class="text-capitalize"
                :variant="``"
            >
              {{ data.item.walletId }}
            </b-badge>
          </template>

          <!-- Column: credit -->
          <template #cell(credit)="data">
            <span>
               {{ makePrettyPrice(data.item.credit) }}
            </span>
          </template>

          <!-- Column: updateDate -->
          <template #cell(updateDate)="data">
            <span>
              {{data.item.updateDate.slice(11,16)}}
              -
              {{createJalaliDate(data.item.updateDate.slice(0,10))}}
            </span>
          </template>

          <!-- Column: state -->
          <template #cell(userInfo.state)="data">
            <b-badge
                v-if="data.item.userInfo.state === 1"
                pill
                class="text-capitalize"
                :variant="`success`"
            >
              وارد شده
            </b-badge>
            <b-badge
                v-else-if="data.item.userInfo.state === 2"
                pill
                class="text-capitalize"
                :variant="`warning`"
            >
              فالو نکرده
            </b-badge>
            <b-badge
                v-else-if="data.item.userInfo.state === 3"
                pill
                class="text-capitalize"
                :variant="`danger`"
            >
              آیدی اشتباه
            </b-badge>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">


                <b-link :to="{ name: 'apps-financial-wallets-info', params: { id: data.item.userId } }">
                  <feather-icon icon="EditIcon" size="20" />
                </b-link>
              </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalCounts"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon style="transform: rotate(180deg)"
                                icon="ChevronLeftIcon"
                                size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import WalletGetAllRequest from "@/libs/Api/Wallet/WalletGetAllRequest";
import Helper from "@/libs/Helper";

export default {
  name: "WalletsList",
  title:"لیست موجودی ها - پنل ادمین فرادیدار",
  data(){
    return{
      wallets:null,
      currentPage:1,
      totalCounts:null,
      perPage:10,
      perPageOptions:[10, 20, 30 , 40 , 50],
      myTableColumns : [
        { key: 'name' ,label :'اطلاعات کاربر'},
        { key: 'userInfo.nationalId' ,label :'کد ملی'},
        { key: 'userInfo.mobile' ,label :'موبایل'},
        { key: 'userInfo.state' ,label :'وضعیت کاربر'},
        { key: 'walletId' ,label :'شناسه کیف پول'},
        { key: 'credit' ,label :'موجودی(تومان)'},
        { key: 'updateDate' ,label :'آخرین تغییر'},
        { key: 'actions',label:'ویرایش کیف پول'},
      ],
      searchQuery:'',
    }
  },
  async created() {
    await this.getWallets(this.perPage,this.currentPage,this.searchQuery)
  },
  methods:{
    refreshData(){
      this.getWallets(this.perPage,this.currentPage,this.searchQuery)
    },
    async getWallets(count,pageNumber,search){
      let _this = this;
      let data = {
        pageNumber:pageNumber,
        count:count,
        search:search
      }

      let walletGetAllRequest = new WalletGetAllRequest(_this);
      walletGetAllRequest.setParams(data);
      await walletGetAllRequest.fetch(function (content){
        _this.wallets = content.wallets;
        _this.totalCounts = content.walletsCount;
      },function (error){
        console.log(error);
      })
    },
    createJalaliDate(param){
      return new Date(param).toLocaleDateString("fa-IR",);
    },
    makePrettyPrice(param){
      return Helper.prettyPrice(param,0)
    },
  },
  watch:{
    perPage:function (nv,ov){
      this.getWallets(nv,this.currentPage,this.searchQuery);
    },
    currentPage:function (nv,ov) {
      this.getWallets(this.perPage,nv,this.searchQuery);
    },
    searchQuery:function (nv,ov){
      this.getWallets(this.perPage,this.currentPage,nv)
    },
  },
  components: {

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,

    vSelect,
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
